import type { ReactNode } from "react";

// 로그인 · 회원가입 · Contact Us 영역 공용 조각 (Figma ver.7). 기존 공용 컴포넌트(NvFormField · NvButton)는 건드리지 않고 덧붙여요.

// 필수(*) 표시는 주황 (#FD5108). NvFormField · NvDropdownField의 label 자리에 넣어요 (그때는 required 대신 aria-required를 써요).
// data-required-mark: 글자 대조 도구(compare.js)가 "라벨 *" 한 덩어리로 읽도록 시험 때만 풀어 쓰는 표식
function NvRequiredLabel({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <span data-required-mark className="text-nv-brand">
        {" *"}
      </span>
    </>
  );
}

// 필수 입력 · 동의가 채워지기 전 비활성 기본 버튼 (Figma ver.7: 채움 #F3F4F6 · 글자 #A1A8B3, 흐림 없음)
const NV_PRIMARY_DISABLED_CLASS = "disabled:bg-nv-bg-subtle disabled:text-nv-text-placeholder disabled:opacity-100";

// 링크 밑줄 (Figma 로그인 · 회원가입 링크: 1px 주황 밑줄)
const NV_BRAND_UNDERLINE_CLASS = "underline decoration-nv-brand decoration-1 underline-offset-[3px]";

export { NvRequiredLabel, NV_PRIMARY_DISABLED_CLASS, NV_BRAND_UNDERLINE_CLASS };
